/**
 * RightSideModal.js
 * Talkroute
 *
 * Created by Vel Genov on 2/12/20
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import React from "react";
import os from "os";

interface IRightSideModalProps {
  id?: string;
}

/**
 * A React component responsible for displaying the modal dialog in the right side of app
 */
class RightSideModal extends React.Component<IRightSideModalProps> {
  render() {
    const { children, id } = this.props;
    const top = os.platform() === "win32" ? "28px" : "0";

    return (
      <div
        id={id}
        style={{
          zIndex: 8,
          position: "fixed",
          height: "100%",
          width: "100%",
          top: "0",
          left: "0",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "var(--color-light-grey)",
            opacity: "0.8",
            position: "absolute",
            top,
          }}
        />
        <div
          style={{
            paddingTop: "60px",
            paddingLeft: "250px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top,
          }}
        >
          <div
            style={{
              backgroundColor: "var(--color-white)",
              width: "400px",
              border: "1px solid var(--color-dark-grey)",
              borderRadius: "20px",
              boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.1)",
            }}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default RightSideModal;
